<template>
  <PmNotificationExternalServiceRequestDeclinedNoticePure
    v-bind="{ ...$attrs, ...props }"
    :is-jump-visible="can('approve', 'requests')"
    @open-details="isDetailsVisible = true"
  />

  <portal to="modal">
    <PmModalPure
      v-if="isDetailsVisible"
      title="Antrag Fremddienstleistung"
      @close="isDetailsVisible = false"
    >
      <PmRequestDetail
        v-if="isDetailsVisible"
        :id="props.externalServiceRequestId"
        type="externalServiceRequest"
      />
    </PmModalPure>
  </portal>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import PmNotificationExternalServiceRequestDeclinedNoticePure, {
  type Props as PropsNotificationExternalServiceRequestDeclinedNoticePure,
} from '@/components/PmNotification/PmNotificationExternalServiceRequestDeclinedNotice/PmNotificationExternalServiceRequestDeclinedNoticePure.vue'
import PmRequestDetail from '@/components/PmRequestDetail/PmRequestDetail.vue'
import PmModalPure from '@/components/basics/PmModalPure.vue'
import { useAppAbility } from '@/composition/useAppAbility'

export type Props = PropsNotificationExternalServiceRequestDeclinedNoticePure

const props = withDefaults(defineProps<Props>(), {})

const isDetailsVisible = ref(false)
const { can } = useAppAbility()
</script>
